import type { BlogPost } from '../../app/features/blog/blog.types';
import { RAW_POSTS_2026 } from './archive/posts-2026';

type RawPost = Omit<BlogPost, 'readingTimeMinutes'>;

/**
 * Registry of all blog posts grouped by year/archive.
 * New posts can be added directly here or in new archive files.
 */
const RAW_POSTS: readonly RawPost[] = [
  ...RAW_POSTS_2026,
  // Add future years here: ...RAW_POSTS_2027
];

/**
 * Calculates reading time in minutes based on word count.
 */
function calculateReadingTime(content: string): number {
  const words = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 200));
}

/**
 * Final exported POSTS array, processed with reading time and sorted by date.
 */
export const POSTS: readonly BlogPost[] = RAW_POSTS.map((post) => ({
  ...post,
  readingTimeMinutes: calculateReadingTime(post.content),
})).sort((a, b) => (a.date < b.date ? 1 : -1));
